import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  type: 'success' | 'error';
  message: string;
}

const TOAST_DURATION_MS = 4000;

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 0;

  readonly toasts = signal<Toast[]>([]);

  success(message: string): void {
    this.show('success', message);
  }

  error(message: string): void {
    this.show('error', message);
  }

  dismiss(id: number): void {
    this.toasts.update((toasts) => toasts.filter((toast) => toast.id !== id));
  }

  private show(type: Toast['type'], message: string): void {
    const toast: Toast = { id: ++this.nextId, type, message };
    this.toasts.update((toasts) => [...toasts, toast]);

    setTimeout(() => this.dismiss(toast.id), TOAST_DURATION_MS);
  }
}
